import { render, staticRenderFns } from "./ArrangeForServicePoInstructions.vue?vue&type=template&id=5e5f65ee"
import script from "./ArrangeForServicePoInstructions.vue?vue&type=script&lang=ts"
export * from "./ArrangeForServicePoInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports